import React, { useMemo } from "react";
import { compose } from "redux";
import clone from "lodash/clone";
import { withStyles, withBreakpoint } from "components/common";
import { convertToShortDate } from "utils/convert-date";
import Table from "components/common/Table";
import formatCurrency from "utils/formatCurrency";

const computeColumns = isMobile =>
  isMobile
    ? [
        {
          Header: "Statement Date",
          accessor: 'end_date',
          Cell: ({ value }) => convertToShortDate(value)
        },
        {
          Header: "Balance",
          accessor: data => data.ending_balance,
          Cell: ({ value }) => (
            <div className="flex justify-end items-center">
              <p className="mr-4">{`${formatCurrency(value.toFixed(2))}`}</p>
              <i className="fas fa-file-download px-0" />
            </div>
          )
          // accessor: data => `$${-data.ending_balance.toFixed(2)}`
        },
        // {
        //   id: 1,
        //   accessor: data => <i className="fas fa-file-download px-0" />
        // }
      ]
    : [
        {
          Header: "Statement Date",
          accessor: 'end_date',
          Cell: ({ value }) => convertToShortDate(value)
        },
        // {
        //   Header: "Payment Due",
        //   accessor: 'payment_due_date',
        //   Cell: ({ value }) => convertToShortDate(value)
        // },
        {
          Header: "Purchases",
          accessor: 'debits',
          Cell: ({ value }) => `${formatCurrency(value.toFixed(2))}`
        },
        {
          Header: "Ending Balance",
          accessor: data => data.ending_balance,
          Cell: ({ value }) => `${formatCurrency(value.toFixed(2))}`
        },
        {
          Header: "Open or Save",
          unsortable: true,
          accessor: data => (
            <div className="flex mr-1">
              <a href={data.pdf_url} target="_blank" rel="noopener noreferrer">
                <i className="fas fa-file-pdf" />
              </a>
              {/* <a href={data.csv_url}>
                <i className="px-4 fas fa-file-csv" />
              </a> */}
              {/* <a href={data.pdf_url} target="_blank" rel="noopener noreferrer" download>
                <i className="fas fa-file-download" />
              </a> */}
            </div>
          )
        }
      ];

const StatementsTable = ({ breakpointContext: { isBelow }, statements }) => {
  const belowMd = isBelow("md");
  const columns = useMemo(() => computeColumns(belowMd), [belowMd]);

  return (
    <div>
      <div className="my-6">
        {statements.length ? (
          <Table
            id="transactions-table"
            data={clone(statements)}
            columns={columns}
            onRowClick={(e, row) => {
              if (isBelow("md")) {
                const { original: { pdf_url } = {} } = row;
                const win = window.open(pdf_url, "_blank");
                win.focus();
              }
            }}
          />
        ) : (
          <div>You don't have any statements yet!</div>
        )}
      </div>
    </div>
  );
};

export default compose(withStyles, withBreakpoint)(StatementsTable);
